import React from 'react';
import './Header.css'
function Header(){
    return(
        <header>
            <img 
               src="http://www.pngall.com/wp-content/uploads/2016/05/Trollface.png" 
               alt="Problem?"
               className='img1'
            />
            <p>Meme Generator</p>
        </header>
    )

}
export default Header